import { configureStore } from '@reduxjs/toolkit';
import headerSlice from '../features/common/headerSlice';
import modalSlice from '../features/common/modalSlice';
import rightDrawerSlice from '../features/common/rightDrawerSlice';
import classesSlice from '../features/classes/classesSlice';

import { apiSlice } from './apiSlice';
import { setupListeners } from '@reduxjs/toolkit/query';
import authReducer from './authSlice';

const combinedReducer = {
  auth: authReducer,
  header: headerSlice,
  rightDrawer: rightDrawerSlice,
  modal: modalSlice,
  classes: classesSlice,

  [apiSlice.reducerPath]: apiSlice.reducer,
};

const store = configureStore({
  reducer: combinedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(apiSlice.middleware), // RTK Query middleware
});

setupListeners(store.dispatch);
export default store;
